import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'next',
                prev: 'prev',
                close: 'close'
            }
        }

        this.$faces = this.$('face')
        this.$wallpapers = this.$('wallpaper')
        this.$contents = this.$('content')

        this.imageLoads = []
    }

    init() {

    }

    showById(options) {
        if(!options.id && this.isOpened) return

        this.targetId = options.id
        this.targetReversed = options.odd != undefined ? !options.odd : this.targetReversed

        if(!this.changeRequested) {
            this.changeRequested = true

            this.hidePromise = new Promise(resolve => {
                // OLD ONE
                // ==========================================================================

                let oldFace = Array.from(this.$faces).find(candidate => {
                    return candidate.classList.contains('is-active')
                })

                let oldWallpaper = Array.from(this.$wallpapers).find(candidate => {
                    return candidate.classList.contains('is-active')
                })

                let oldContent = Array.from(this.$contents).find(candidate => {
                    return candidate.classList.contains('is-active')
                })

                if(oldFace)
                    oldFace.classList.remove('is-active')
                if(oldWallpaper)
                    oldWallpaper.classList.remove('is-active')
                if(oldContent)
                    oldContent.classList.remove('is-active')

                setTimeout(resolve, 250);
            }).then(() => {
                if(this.targetReversed) this.el.classList.add('is-reversed')
                else this.el.classList.remove('is-reversed')

                // NEW ONE
                // ==========================================================================

                let newFace = Array.from(this.$faces).find(candidate => {
                    return this.getData('id', candidate) == this.targetId
                })

                let newWallpaper = Array.from(this.$wallpapers).find(candidate => {
                    return this.getData('id', candidate) == this.targetId
                })

                let newContent = Array.from(this.$contents).find(candidate => {
                    return this.getData('id', candidate) == this.targetId
                })

                let emoji = this.getData('emoji', newContent)
                this.call('setTexture', emoji, 'Rainmoji', 'team-modal')

                if(newFace)
                    newFace.classList.add('is-active')
                if(newWallpaper)
                    newWallpaper.classList.add('is-active')
                if(newContent)
                    newContent.classList.add('is-active')

                // Async load
                if(newFace && newWallpaper) {
                    if(!newFace.classList.contains('is-loaded')) {
                        this.loadAsset(newFace)
                    }
                    if(!newWallpaper.classList.contains('is-loaded')) {
                        this.loadAsset(newWallpaper)
                    }
                }

                this.changeRequested = false
            })
        }
    }

    loadAsset(el) {
        // Toggle loading state
        this.el.classList.add('is-loading-members')

        // Generate image object and push it to loading array
        let src = this.getData('img', el)
        let img = new Image()
        this.imageLoads.push(img)

        let loadCallback = () => {
            el.style.backgroundImage = `url('${src}')`
            el.classList.add('is-loaded')
            this.imageLoads = this.imageLoads.filter(item => item !== img)
            if(!this.imageLoads.length) {
                this.el.classList.remove('is-loading-members')
            }
        }

        // Try to use `decode` if available (to prevent jank), otherwise use the standard `onload`
        if(img.decode) {
            img.src = src
            img.decode().then(loadCallback).catch(err => {
                console.error(err)
            })
        } else {
            img.onload = loadCallback
            img.src = src
        }
    }

    next() {
        this.showById({ id: this.getPosition().nextId, odd: !this.targetReversed})
    }

    prev() {
        this.showById({ id: this.getPosition().prevId, odd: !this.targetReversed})
    }

    getPosition() {
        const currentContent = Array.from(this.$contents).find(candidate => {
            return candidate.classList.contains('is-active')
        })
        const currentId = this.getData('id', currentContent)

        const nextContent = currentContent.nextElementSibling ? currentContent.nextElementSibling : currentContent.parentNode.children[0]
        const nextId = this.getData('id', nextContent)

        const prevContent = currentContent.previousElementSibling ? currentContent.previousElementSibling : currentContent.parentNode.children[currentContent.parentNode.children.length-1]
        const prevId = this.getData('id', prevContent)

        return { currentId, nextId, prevId }
    }

    open() {
        this.isOpened = true
        this.el.classList.add('is-opened')

        this.call('setActive', true, 'Rainmoji', 'team-modal')
    }

    close() {
        this.el.classList.remove('is-opened')
        this.isOpened = false
        this.showById({ id: false, odd: !this.targetReversed})
        this.call('setActive', false, 'Rainmoji', 'team-modal')
    }
}
